import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { useLocation, matchPath } from "react-router-dom";


interface PopupContextType {
  isPopupOpen: boolean;
  closePopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation(); // Get current route

  useEffect(() => {
    const sessionData = sessionStorage.getItem("sessionId");
    const firstVisit = localStorage.getItem("firstVisit");



   
    const isPopup =
      matchPath("/:lang?/", location.pathname) ||
      matchPath("/:lang?/metaverse", location.pathname) ||
      matchPath("/:lang?/project/:project", location.pathname) ||
      matchPath("/:lang?/blogs", location.pathname) ||
      matchPath("/:lang?/blog/:slug", location.pathname) ||
      matchPath("/:lang?/blog/tag/:slug", location.pathname) ||
      matchPath("/:lang?/charity", location.pathname) ||
      matchPath("/:lang?/projects", location.pathname) ||
      matchPath("/:lang?/shop", location.pathname) ||
      matchPath("/:lang?/project/:project/:product", location.pathname) ||
      matchPath("/:lang?/shop", location.pathname);

    if (!sessionData && !firstVisit && isPopup) {
      setTimeout(() => {
        setIsPopupOpen(true);
      }, 1000);
    }

   
  }, [location.pathname]);

  const closePopup = () => {
    setIsPopupOpen(false);

    sessionStorage.setItem("sessionId", "true");
    localStorage.setItem("firstVisit", "true"); 

  };
  return (
    <PopupContext.Provider value={{ isPopupOpen, closePopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = (): PopupContextType => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error("usePopup must be used within a PopupProvider");
  }
  return context;
};
